module.exports = __webpack_public_path__ + "img/location.1ab5be11.svg";